// CSS
import 'reset-css';
import './scss/main.scss';
import '@fortawesome/fontawesome-pro/css/regular.min.css';
import '@fortawesome/fontawesome-pro/css/fontawesome.min.css';

// JS
import {plugins} from './js/plugins';
import {charts} from './js/charts';
import {tables} from './js/tables';
import {editing} from './js/editing';
import {app} from './js/app';
import { EDOM } from 'constants';

plugins.init();
charts.init();
editing.init();
app.init();

export {charts};